import React from "react";
import { Table, Tag } from "antd";

const DistributionsTable = ({ distributions, loading }) => {
  const getStatusColor = (status) => {
    const colors = {
      Prepared: "blue",
      Ready: "cyan",
      Collected: "green",
      Verified: "success",
      Discrepancy: "error",
    };
    return colors[status] || "default";
  };

  const columns = [
    {
      title: "Item",
      dataIndex: "item_name",
      key: "item_name",
    },
    {
      title: "Brand",
      dataIndex: "brand_name",
      key: "brand_name",
    },
    {
      title: "Size",
      dataIndex: "size_name",
      key: "size_name",
      render: (text) => text || "-",
    },
    {
      title: "Qty Prepared",
      dataIndex: "quantity_prepared",
      key: "quantity_prepared",
      align: "center",
    },
    {
      title: "Qty Collected",
      dataIndex: "quantity_collected",
      key: "quantity_collected",
      align: "center",
      render: (qty) => qty || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
    },
    {
      title: "Collected By",
      dataIndex: "collected_by",
      key: "collected_by",
      render: (name) => name || "-",
    },
    {
      title: "Verified",
      key: "verified",
      align: "center",
      render: (_, record) => {
        if (record.verified) {
          return <Tag color="success">Verified</Tag>;
        }
        return "-";
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={distributions}
      loading={loading}
      rowKey="id"
      pagination={false}
      size="small"
      scroll={{ x: 900 }}
    />
  );
};

export default DistributionsTable;
